import React from 'react'
import PropTypes from 'prop-types'
import { getColor } from 'src/styles'
import { mergeProps } from 'src/util'
import styles from './Logo.scss'

/**
 * An insanely futuristic Labguard logo.
 */
const Logo = ({ primaryColor, secondaryColor, companyColor, withBrand, withShadow, ...domProps }) => {
  primaryColor = getColor(primaryColor)

  return (
    <svg {...mergeProps()({ className: styles.logo }, domProps)} viewBox={`0 0 545.56 ${withBrand ? '509.65' : '387'}`}>
      <defs>
        <linearGradient id="gradient" x1="94.2" y1="334.9" x2="438.91" y2="334.9" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ffe000" />
          <stop offset="0.14" stopColor="#fcdf01" />
          <stop offset="0.25" stopColor="#f2db03" />
          <stop offset="0.36" stopColor="#e0d406" />
          <stop offset="0.46" stopColor="#c8cb0b" />
          <stop offset="0.56" stopColor="#a9bf11" />
          <stop offset="0.65" stopColor="#83b019" />
          <stop offset="0.74" stopColor="#569e22" />
          <stop offset="0.79" stopColor="#399328" />
        </linearGradient>
        <filter id="logo-inset-shadow">
          <feOffset dx="0" dy="5" />
          <feGaussianBlur stdDeviation="3" result="offset-blur" />
          <feComposite operator="out" in="SourceGraphic" in2="offset-blur" result="inverse" />
          <feFlood floodColor="black" floodOpacity="0.33" result="color" />
          <feComposite operator="in" in="color" in2="inverse" result="shadow" />
          <feComposite operator="over" in="shadow" in2="SourceGraphic" />
        </filter>
      </defs>
      <title>Labguard</title>
      <g id="container">
        <g id="Logo" filter={withShadow ? 'url(#logo-inset-shadow)' : ''}>
          <path
            fill={primaryColor}
            d="M266.56,0C159.55,0,72.81,86.74,72.81,193.74a194.47,194.47,0,0,0,4.32,40.8H456a194.47,194.47,0,0,0,4.32-40.8C460.3,86.74,373.56,0,266.56,0Z"
          />
          <path
            fill={secondaryColor ? secondaryColor : 'url(#gradient)'}
            d="M94.2,282.31a193.81,193.81,0,0,0,344.72,0Z"
          />
          <path
            fill={companyColor}
            d="M96.87,161.36h14c6.43,0,12.48,1.56,12.48,8.65,0,5-3.12,7.33-6.67,8v.09c4.25.76,7.61,3,7.61,8.56,0,7-6.19,9.64-12.72,9.64H96.87Zm13.24,14.42c4,0,5.86-1.51,5.86-4.21s-1.65-4.25-5.77-4.25h-5.77v8.46Zm.52,14.7c4.25,0,6.15-1.7,6.15-4.68s-2.22-4.59-6.48-4.59h-5.86v9.27Z"
          />
          <path fill={companyColor} d="M135.67,161.36h7.66v35h-7.66Z" />
          <path
            fill={companyColor}
            d="M154,178.85c0-12.29,8-18.15,16.5-18.15s16.45,5.86,16.45,18.15-8,18.15-16.45,18.15S154,191.14,154,178.85Zm25.29,0c0-7.33-3.4-11.77-8.79-11.77s-8.79,4.44-8.79,11.77,3.36,12,8.79,12S179.26,186.18,179.26,178.85Z"
          />
          <path
            fill={companyColor}
            d="M197.22,161.36h10.16l7.8,25.72h.09l7.28-25.72H233v35h-7.42V172.47h-.09a62.78,62.78,0,0,1-1.94,7.8l-5.25,16.07h-6.81l-5.2-16.07a62.07,62.07,0,0,1-2-8.18h-.09v24.25h-6.9Z"
          />
          <path
            fill={companyColor}
            d="M244.86,161.36h23.82v6.43H252.57v7.52h11.68v6.1H252.57v8.7h17v6.24H244.86Zm12-10.26h7.66l-7,8.18h-5Z"
          />
          <path
            fill={companyColor}
            d="M279.51,161.36h13.14c8.6,0,13.76,3.07,13.76,10.83,0,5.53-2.6,8.56-7.28,10l7.8,14.18H298.8l-7.28-13.19h-4.44v13.19h-7.56Zm12.81,15.84c4.44,0,6.57-1.28,6.57-4.82s-2.13-4.73-6.57-4.73h-5.25v9.55Z"
          />
          <path fill={companyColor} d="M317.94,161.36h7.66v35h-7.66Z" />
          <path fill={companyColor} d="M337.89,161.36h23.83v6.43H345.59v7.52h11.68v6.1H345.59v8.7h17v6.24H337.89Z" />
          <path
            fill={companyColor}
            d="M371.49,183v-21.6h7.71v21.41c0,5.06,1.94,7.89,6.52,7.89s6.43-2.79,6.43-7.89V161.36h7.56v21.56c0,8.6-4.35,14-14.09,14S371.49,191.52,371.49,183Z"
          />
          <path
            fill={companyColor}
            d="M419.71,177.86l-10.21-16.5h8.79l6.24,10.49,5.91-10.49h7.94l-10,16.54,11.35,18.44h-8.56l-7.42-12.24-7.19,12.24H408.5Z"
          />
        </g>
        {withBrand && (
          <g id="brand" filter={withShadow ? 'url(#logo-inset-shadow)' : ''}>
            <path fill={primaryColor} d="M0,508.27V435.38H8.67v65H43.73v7.88Z" />
            <path
              fill={primaryColor}
              d="M50.23,508.27,76,435.09h9.06l25.81,73.18h-9l-7.19-20.88h-29L58.6,508.27ZM68.45,479.8H92.09L80.47,445.62h-.2Z"
            />
            <path
              fill={primaryColor}
              d="M123,508.27V435.38h26.1c15.86,0,24.92,6.11,24.92,18.22,0,9.95-6,15.27-13.49,16.84v.2c9,1.67,15.86,7.09,15.86,17.73,0,12.21-9.06,19.9-25.21,19.9Zm8.57-41.07h16.74c10.93,0,17.24-3.84,17.24-12.21s-5.22-11.92-17-11.92H131.58Zm0,33.49h19c11.92,0,17.24-4.53,17.24-12.9,0-9.16-7.29-13.1-19-13.1H131.58Z"
            />
            <path
              fill={primaryColor}
              d="M187,471.53c0-23.15,12.8-37.53,31-37.53,13.79,0,23.15,7.29,27,22.56L237,458.63C233.52,446.91,228.1,442,218,442c-11.43,0-22.16,8.77-22.16,29.25s9.55,30.63,22.46,30.63c11.33,0,19-7.68,19.21-21.18H220.71V473.4h25.12v34.87h-7.58V497.34H238c-2.86,6-9.26,12.31-20.59,12.31C197.76,509.65,187,493.59,187,471.53Z"
            />
            <path
              fill={primaryColor}
              d="M260.8,483.05V435.38h8.67v46.49c0,11.72,5.61,19.9,18.52,19.9,12.71,0,18.32-7.88,18.32-19.7V435.38h8.57v47.47c0,15.17-9,26.69-27,26.69C269.17,509.55,260.8,498.12,260.8,483.05Z"
            />
            <path
              fill={primaryColor}
              d="M323.53,508.27l25.81-73.18h9.06l25.81,73.18h-9l-7.19-20.88h-29l-7.19,20.88Zm18.22-28.46h23.64l-11.62-34.18h-.2Z"
            />
            <path
              fill={primaryColor}
              d="M396.32,508.27V435.38h25c16.55,0,25.9,7,25.9,20.39,0,11.72-6.6,17.83-16.94,20l17.93,32.5h-9.46l-17.43-31.42H404.89v31.42Zm8.57-39.1h16c11.43,0,17.83-3.15,17.83-13.1,0-9.55-6.3-12.8-17.93-12.8H404.89Z"
            />
            <path
              fill={primaryColor}
              d="M463,508.27V435.38H482.2c23.44,0,36.74,11.82,36.74,36.25,0,24.72-13.59,36.64-36.74,36.64Zm8.67-7.78h11.62c17.63,0,27-8.57,27-28.86,0-19.6-9.46-28.27-27.18-28.27H471.66Z"
            />
            <path
              fill={primaryColor}
              d="M526.17,444.3a9.7,9.7,0,1,1,9.7,9.78A9.68,9.68,0,0,1,526.17,444.3Zm18,0a8.29,8.29,0,1,0-8.27,8.4A8.33,8.33,0,0,0,544.18,444.3Zm-11.92-5.58h3.82c2.48,0,3.86,1.09,3.86,3.11a2.79,2.79,0,0,1-2.27,3l2.56,4.7h-1.8L536,445h-2.06v4.49h-1.68Zm3.74,4.91c1.43,0,2.31-.42,2.31-1.72s-.88-1.68-2.35-1.68h-2v3.4Z"
            />
          </g>
        )}
      </g>
    </svg>
  )
}

Logo.defaultProps = {
  primaryColor: 'primary',
  companyColor: 'white',
  withBrand: true,
}

Logo.propTypes = {
  /**
   * The primary logo color.
   */
  primaryColor: PropTypes.string,
  /**
   * The secondary logo color.
   */
  secondaryColor: PropTypes.string,
  /**
   * The company color.
   */
  companyColor: PropTypes.string,
  /**
   * Whether to show the brand text.
   */
  withBrand: PropTypes.bool,
  /**
   * Whether to show an inner shadow.
   */
  withShadow: PropTypes.bool,
}

export default Logo
